module.exports = __webpack_public_path__ + "img/close_gray.ca6cc7c6.svg";